import classnames from 'classnames'
import React from 'react'
import { Text } from '../../elements/Text'
import { mq } from '../../utils'
import { ISortOption } from './index'
import useTranslate from 'marketing-site/src/library/hooks/useTranslate'

interface IProps {
  sortOptions: ISortOption[]
  handleToggleSortOptions: Function
}

export const Sorter = ({ sortOptions, handleToggleSortOptions }: IProps) => {
  const { translate } = useTranslate()

  return (
    <div className="sorter">
      <div className="sorter__heading">
        <Text brand="default" size="heading-4">
          {translate(`In this series:`)}
        </Text>
      </div>
      <div className="sorter__tabs">
        <div className="sorter__tabs__label">
          <Text size="caption">{translate('Sort by:')}</Text>
        </div>
        {sortOptions && (
          <ul className="sorter__tab__list" role="listbox">
            {sortOptions.map((option) => {
              const radioClassNames = classnames('sorter__tab__radio', {
                'is-active': option.selected,
              })
              return (
                <li
                  className="sorter__tab"
                  role="option"
                  aria-selected={option.selected}
                  key={option.name}
                >
                  <button
                    className={radioClassNames}
                    role="radio"
                    aria-checked={option.selected}
                    onClick={() => {
                      if (option.selected) {
                        return
                      } else {
                        handleToggleSortOptions(option.value)
                      }
                    }}
                  >
                    {option.name}
                  </button>
                </li>
              )
            })}
          </ul>
        )}
      </div>
      <style jsx>{`
        .sorter {
          display: flex;
          flex-direction: column;
          flex-wrap: wrap;
        }

        .sorter__heading {
          flex: 0 0 50%;
          margin-bottom: 0.5rem;
        }

        .sorter__tabs {
          align-items: center;
          display: flex;
          flex-wrap: wrap;
        }

        .sorter__tabs__label {
          margin-right: 2.125rem;
          margin-top: 1rem;
        }

        .sorter__tab__list {
          margin-top: 1rem;
        }

        .sorter__tab {
          display: inline-flex;
        }

        .sorter__tab:first-of-type .sorter__tab__radio {
          border-top-right-radius: 0;
          border-bottom-right-radius: 0;
        }

        .sorter__tab:nth-of-type(2):not(:last-of-type) .sorter__tab__radio {
          border-top-right-radius: 0;
          border-bottom-right-radius: 0;
          border-left: none;
        }

        .sorter__tab:last-of-type .sorter__tab__radio {
          border-top-left-radius: 0;
          border-bottom-left-radius: 0;
          border-left: none;
        }

        .sorter__tab:not(:first-of-type):not(:last-of-type) .sorter__tab__radio {
          border-radius: 0;
        }

        .sorter__tab__radio {
          cursor: pointer;
          border: 2px solid $slate;
          border-radius: 30px;
          padding: 0.375rem 1.25rem;
        }

        .sorter__tab__radio.is-active {
          background: $stone;
          cursor: initial;
        }

        @media (${mq.tablet}) {
          .sorter {
            align-items: center;
            flex-direction: row;
            justify-content: space-between;
          }

          .sorter__heading {
            flex: 0 0 auto;
            margin-bottom: 0;
          }

          .sorter__tabs__label {
            margin-top: 0;
          }

          .sorter__tab__list {
            margin-top: 0;
          }
        }
      `}</style>
    </div>
  )
}
